/* eslint-disable react-hooks/exhaustive-deps */

import { useRef, useEffect, type EffectCallback } from "react";

function useMountEffect(effect: EffectCallback) {
  const ref = useRef(false);
  useEffect(() => {
    if (ref.current) return;
    ref.current = true;
    effect();
  }, []);
}

export default useMountEffect;
